import { render, staticRenderFns } from "./DashStatistics.vue?vue&type=template&id=3a5eccc6&"
import script from "./DashStatistics.vue?vue&type=script&lang=js&"
export * from "./DashStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports